import { render, staticRenderFns } from "./rankings-component.vue?vue&type=template&id=1df9e7a7&scoped=true&"
import script from "./rankings-component.vue?vue&type=script&lang=js&"
export * from "./rankings-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df9e7a7",
  null
  
)

export default component.exports